<template>
  <div class="brands-alphabet">
    <div class="brands-alphabet__letters">
      <span class="brands-alphabet__letters-title">Бренды:</span>
      <div class="brands-alphabet__letters-items">
        <a
          @mouseenter="active = i"
          @click.prevent
          v-for="(chunk, i) in brands_chunks"
          :key="i"
          class="brands-alphabet__letters-item no-hover"
          :class="{ active: active === i }"
          href="#"
        >
          <template v-if="chunk.title">
            {{ chunk.title }}
          </template>
          <template v-else>
            <template v-if="chunk[0]">
              {{ chunk[0].title }}
            </template>
            <template v-if="chunk[1]">
              {{ chunk[1].title }}
            </template>
          </template>
        </a>
      </div>
    </div>
    <div
      v-show="active === index"
      v-for="(chunk, index) in brands_chunks"
      :key="index"
      class="brands-alphabet__chunk"
    >
      <div
        v-for="(letter, key) in chunk && chunk.length ? chunk : chunk.list"
        :key="key"
        class="brands-alphabet__letter-row"
      >
        <span class="brands-alphabet__letter-title">{{ letter.title }}</span>
        <ul class="brands-alphabet__letter-list">
          <li class="brands-alphabet__letter-item" v-for="(item, i) in letter.list" :key="i">
            <router-link
              class="brands-alphabet__letter-link"
              :to="{ name: 'catalog', query: { brands_item_id: item.id } }"
            >
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandsAlphabetComponent",
  data() {
    return {
      active: 0,
      regexp: {
        ru: /[А-яЁё]/,
        en: /^[a-z]+$/i,
        num: /[0-9]/,
      },
    };
  },
  computed: {
    brands() {
      return this.$store.state.all_brands || [];
    },
    // сортировка по алфавиту
    brands_sorted() {
      let brands = [...this.brands];
      return brands.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
    },
    brands_chunks() {
      let list = this.sliceIntoChunks(this.getSections(this.brands_sorted, this.regexp.en), 2);
      list.push({ title: "А - Я", list: this.getSections(this.brands_sorted, this.regexp.ru) });
      list.push({ title: "0 - 9", list: this.getSections(this.brands_sorted, this.regexp.num) });
      return list.filter((l) => l.length);
    },
  },
  methods: {
    // разделение по буквам
    getSections(list, regexp) {
      if (list.length === 0) {
        return [];
      }
      return Object.values(
        list.reduce((acc, word) => {
          let firstLetter = word.title[0].toLocaleUpperCase();
          if (regexp.test(firstLetter)) {
            if (!acc[firstLetter]) {
              acc[firstLetter] = { title: firstLetter, list: [word] };
            } else {
              acc[firstLetter].list.push(word);
            }
          }
          return acc;
        }, {})
      );
    },
    // разделение массива на блоки по chunkSize (2 например)
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        res.push(arr.slice(i, i + chunkSize));
      }
      return res;
    },
  },
};
</script>

<style lang="stylus">
.brands-alphabet {
  display flex
  flex-direction column
  gap 20px

  &__letters {
    display flex
    align-items center
    gap 10px

    &-title {
      font-weight: 700;
      font-size: 0.875em
      line-height: 114%
      flex-shrink 0
    }

    &-items {
      display flex
      flex-wrap wrap
      align-items center
      gap 5px
    }

    &-item {
      display flex
      font-weight: 700;
      font-size: 0.875em
      line-height: 1
      background: var(--gray)
      border-radius: 5px;
      padding 2px 5px
      color var(--dark)
      text-transform uppercase

      &.active {
        background var(--main-color-75)
        color var(--white)
      }
    }
  }

  &__chunk {
    display flex
    flex-direction column
    gap 15px
    max-height 310px
    overflow-y auto
  }

  &__letter {
    &-row {
      display flex
      flex-direction column
      gap 10px
      flex-shrink 0
    }

    &-title {
      font-weight 700
    }

    &-list {
      display grid
      grid-template-columns repeat(5, 1fr)
      column-gap 30px
      +below(560px) {
        grid-template-columns repeat(3, 1fr)
        column-gap 10px
      }
    }

    &-link {
      display flex
      font-size: 0.875em
      line-height: 180%
    }
  }
}
</style>
